module.exports = __webpack_public_path__ + "img/flip_horizontal_left.8db116be.svg";